<ng-container *ngIf="!isDGPBenifts">
    <section class="tw-bg-[#F7F7F7] tw-py-10 tw-px-[25px] md:tw-px-[30px]">
        <div class="tw-mx-auto tw-max-w-[1280px]">
            <p
                class="tw-text-center sm:tw-text-left tw-text-[22px] md:tw-text-[28px] tw-w-full tw-text-[#0F3172] tw-font-bold"
            >
                {{
                    "NEW_PRODUCTS.BUSINESS_FINANCING_BENEFITS.TITLE" | translate
                }}
            </p>
            <p
                class="tw-text-center sm:tw-text-left tw-py-2 tw-text-left tw-text-gray-600 !tw-mb-[20px] tw-text-[#1A202C]"
            >
                {{
                    "NEW_PRODUCTS.BUSINESS_FINANCING_BENEFITS.DESCRIPTION"
                        | translate
                }}
            </p>

            <div
                class="tw-hidden sm:tw-grid tw-gap-6 md:tw-grid-cols-2 lg:tw-grid-cols-4 tw-grid-cols-1"
            >
                <!-- Block 1 -->
                <div
                    class="tw-bg-white tw-rounded-2xl tw-shadow-lg tw-p-7 tw-text-center tw-min-h-[300px]"
                >
                    <img
                        src="assets/images/icons/Finance.png"
                        alt="Financing Options"
                        class="tw-mx-auto tw-mb-4 tw-h-16"
                    />
                    <p
                        class="tw-font-bold tw-text-lg tw-mb-2 tw-text-[20px] !tw-h-[56px]"
                    >
                        {{
                            "NEW_PRODUCTS.BUSINESS_FINANCING_BENEFITS.HEADING1"
                                | translate
                        }}
                    </p>
                    <p class="tw-text-black-600">
                        {{
                            "NEW_PRODUCTS.BUSINESS_FINANCING_BENEFITS.HEADING_DESCRIPTION1"
                                | translate
                        }}
                    </p>
                </div>

                <!-- Block 2 -->
                <div
                    class="tw-bg-white tw-rounded-2xl tw-shadow-lg tw-p-7 tw-text-center"
                >
                    <img
                        src="assets/images/icons/Process.png"
                        alt="Seamless Application"
                        class="tw-mx-auto tw-mb-4 tw-h-16"
                    />
                    <p
                        class="tw-font-bold tw-text-lg tw-mb-2 tw-text-[20px] !tw-h-[56px]"
                    >
                        {{
                            "NEW_PRODUCTS.BUSINESS_FINANCING_BENEFITS.HEADING2"
                                | translate
                        }}
                    </p>
                    <p class="tw-text-black-600">
                        {{
                            "NEW_PRODUCTS.BUSINESS_FINANCING_BENEFITS.HEADING_DESCRIPTION2"
                                | translate
                        }}
                    </p>
                </div>

                <!-- Block 3 -->
                <div
                    class="tw-bg-white tw-rounded-2xl tw-shadow-lg tw-p-7 tw-text-center"
                >
                    <img
                        src="assets/images/icons/Wallet.png"
                        alt="Trusted Partners"
                        class="tw-mx-auto tw-mb-4 tw-h-16"
                    />
                    <p
                        class="tw-font-bold tw-text-lg tw-mb-2 tw-text-[20px] !tw-h-[56px]"
                    >
                        {{
                            "NEW_PRODUCTS.BUSINESS_FINANCING_BENEFITS.HEADING3"
                                | translate
                        }}
                    </p>
                    <p class="tw-text-black-600">
                        {{
                            "NEW_PRODUCTS.BUSINESS_FINANCING_BENEFITS.HEADING_DESCRIPTION3"
                                | translate
                        }}
                    </p>
                </div>

                <!-- Block 4 -->
                <div
                    class="tw-bg-white tw-rounded-2xl tw-shadow-lg tw-p-7 tw-text-center"
                >
                    <img
                        src="assets/images/icons/Calculator.png"
                        alt="Smart Tools"
                        class="tw-mx-auto tw-mb-4 tw-h-16"
                    />
                    <p
                        class="tw-font-bold tw-text-lg tw-mb-2 tw-text-[20px] !tw-h-[56px]"
                    >
                        {{
                            "NEW_PRODUCTS.BUSINESS_FINANCING_BENEFITS.HEADING4"
                                | translate
                        }}
                    </p>
                    <p class="tw-text-black-600">
                        {{
                            "NEW_PRODUCTS.BUSINESS_FINANCING_BENEFITS.HEADING_DESCRIPTION4"
                                | translate
                        }}
                    </p>
                </div>
            </div>
        </div>

        <div class="tw-block sm:tw-hidden">
            <div
                class="tw-max-w-[300px] tw-mx-auto tw-w-full tw-overflow-hidden"
            >
                <ngx-slick-carousel
                    class="carousel p-n-s"
                    [config]="slideConfig"
                >
                    <!-- Block 1 -->
                    <div
                        ngxSlickItem
                        class="tw-bg-white tw-rounded-2xl tw-p-4 tw-text-center tw-w-full tw-max-w-[300px] !tw-max-h-[300px] !tw-min-h-[300px] !tw-mr-[20px]"
                    >
                        <img
                            src="assets/images/icons/Finance.png"
                            alt="Financing Options"
                            class="tw-mx-auto tw-mb-4 tw-h-16"
                        />
                        <p
                            class="tw-font-bold tw-text-lg tw-mb-1 tw-text-[20px] !tw-h-[56px] tw-leading-[25px]"
                        >
                            {{
                                "NEW_PRODUCTS.BUSINESS_FINANCING_BENEFITS.HEADING1"
                                    | translate
                            }}
                        </p>
                        <p class="tw-text-black-600">
                            {{
                                "NEW_PRODUCTS.BUSINESS_FINANCING_BENEFITS.HEADING_DESCRIPTION1"
                                    | translate
                            }}
                        </p>
                    </div>

                    <!-- Block 2 -->
                    <div
                        ngxSlickItem
                        class="tw-bg-white tw-rounded-2xl tw-p-4 tw-text-center tw-w-full tw-max-w-[300px] !tw-max-h-[300px] !tw-min-h-[300px] !tw-mr-[20px]"
                    >
                        <img
                            src="assets/images/icons/Process.png"
                            alt="Seamless Application"
                            class="tw-mx-auto tw-mb-4 tw-h-16"
                        />
                        <p
                            class="tw-font-bold tw-text-lg tw-mb-2 tw-text-[20px] !tw-h-[56px] tw-leading-[25px]"
                        >
                            {{
                                "NEW_PRODUCTS.BUSINESS_FINANCING_BENEFITS.HEADING2"
                                    | translate
                            }}
                        </p>
                        <p class="tw-text-black-600">
                            {{
                                "NEW_PRODUCTS.BUSINESS_FINANCING_BENEFITS.HEADING_DESCRIPTION2"
                                    | translate
                            }}
                        </p>
                    </div>

                    <!-- Block 3 -->
                    <div
                        ngxSlickItem
                        class="tw-bg-white tw-rounded-2xl tw-p-4 tw-text-center tw-w-full tw-max-w-[300px] !tw-max-h-[300px] !tw-min-h-[300px] !tw-mr-[20px]"
                    >
                        <img
                            src="assets/images/icons/Wallet.png"
                            alt="Trusted Partners"
                            class="tw-mx-auto tw-mb-4 tw-h-16"
                        />
                        <p
                            class="tw-font-bold tw-text-lg tw-mb-2 tw-text-[20px] !tw-h-[56px] tw-leading-[25px]"
                        >
                            {{
                                "NEW_PRODUCTS.BUSINESS_FINANCING_BENEFITS.HEADING3"
                                    | translate
                            }}
                        </p>
                        <p class="tw-text-black-600">
                            {{
                                "NEW_PRODUCTS.BUSINESS_FINANCING_BENEFITS.HEADING_DESCRIPTION3"
                                    | translate
                            }}
                        </p>
                    </div>

                    <!-- Block 4 -->
                    <div
                        ngxSlickItem
                        class="tw-bg-white tw-rounded-2xl tw-p-4 tw-text-center tw-w-full tw-max-w-[300px] !tw-max-h-[300px] !tw-min-h-[300px] !tw-mr-[20px]"
                    >
                        <img
                            src="assets/images/icons/Calculator.png"
                            alt="Smart Tools"
                            class="tw-mx-auto tw-mb-4 tw-h-16"
                        />
                        <p
                            class="tw-font-bold tw-text-lg tw-mb-2 tw-text-[20px] !tw-h-[56px] tw-leading-[25px]"
                        >
                            {{
                                "NEW_PRODUCTS.BUSINESS_FINANCING_BENEFITS.HEADING4"
                                    | translate
                            }}
                        </p>
                        <p class="tw-text-black-600">
                            {{
                                "NEW_PRODUCTS.BUSINESS_FINANCING_BENEFITS.HEADING_DESCRIPTION4"
                                    | translate
                            }}
                        </p>
                    </div>
                </ngx-slick-carousel>
            </div>
        </div>
    </section>
</ng-container>
